export default __webpack_public_path__ + "static/Metropolis-Bold-3edb0b87652ebb12ce412a20bfe8e4a6.woff2";